import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import ApplicationRole_popup_AddImportType from '../Popups/ApplicationRole_popup_AddImportType';

export interface Props {
    applicationRoleId: number
}

const ApplicationRole_tab_ImportTypes: React.FC<Props> = ({ applicationRoleId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [applicationRoleId]);

    function getTableData() {
        DataService.get<any[]>(`api/v1/ApplicationRoleImportTypes/ByApplicationRole/${applicationRoleId}`)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ApplicationRoleImportTypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Import type', dataProp: 'importTypeName', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateApplicationRole)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtApplicationRoleImportTypes'
                colInfos={colInfos}
                tableData={data}
            />
            {showPopup && <ApplicationRole_popup_AddImportType applicationRoleId={applicationRoleId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}

        </>
    );
}
export default ApplicationRole_tab_ImportTypes;